import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "@/components/ui/dialog";
import LeadForm from "@/components/common/LeadForm";
import { Download } from "lucide-react";

// Gated brochure download. Reuses the existing lead pipeline (source="brochure")
// with full attribution + canonical SUCCESSFUL_LEAD, then routes to the common
// /thank-you page where the official project link + brochure note are shown.
export default function BrochureGate({ project }) {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button data-testid="brochure-download-btn"
          className="mt-3 w-full h-11 inline-flex items-center justify-center gap-2 rounded-md bg-primary text-primary-foreground text-sm font-semibold hover:bg-primary/90 transition-colors">
          <Download className="h-4 w-4" aria-hidden /> Download Brochure
        </button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-md" data-testid="brochure-gate-modal">
        <DialogHeader>
          <DialogTitle className="font-display text-xl">Get the {project.name} Brochure</DialogTitle>
          <DialogDescription>
            Share your details and we'll email you the full brochure and unlock the official project information.
          </DialogDescription>
        </DialogHeader>
        <div className="mt-2">
          <LeadForm source="brochure" variant="minimal" compact submitLabel="Get Project Brochure"
            defaults={{
              project_slug: project.slug, project_name: project.name, property_name: project.name,
              location: project.location_name, region: project.region, form_type: "brochure",
              requirement_type: "Brochure request", official_url: project.official_source_url || null,
            }} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
